<template>
  <div>
    <div class="container-fluid">
      <div class="mb-3" :class="{'section-loading': infoLoading}" style="overflow: hidden;max-height: 175px;">
        <div class="float-left w-75  pr-3" >
          <h4 class="mb-line text-green mt-0 mb-0">{{ categoryInfo.subcategory }}-{{ categoryInfo.category_name }}  
            <a class="text-orange" style="text-decoration:none;">
              <i style="cursor:pointer;" class="icon-attach ml-2" @click="download()"></i>
            </a>
          </h4>
          <div class="mb-line" style=""><span class="font-weight-bold mr-2">{{ categoryInfo.upload_date | dateFormat }} ~ {{ categoryInfo.end_date | dateFormat }}</span></div>
          <div class="mb-line"><span class="font-weight-bold mr-2">{{ categoryInfo.description }}</span></div>
        </div>
        <div class="float-left w-25">
          <div class="mb-line"><span class="font-weight-bold mr-2">維護單位</span> <span>{{ categoryInfo.dev_name }}</span></div>
          <div class=""><span class="font-weight-bold mr-2">聯絡電話</span> <span>{{ categoryInfo.contact }}</span></div>
          <div class="mb-line"><span class="font-weight-bold mr-2">聯絡分機</span> <span>{{ categoryInfo.contact_tel }}</span></div>
          <div :class="{'section-loading': isLoading_btn}">
            <a class="btn btn-default m-0" @click="satisfactionModal" v-if="isBtnEnble">滿意度調查</a>
            <a class="btn btn-default m-0" @click="alreadyDone" disabled="disabled" v-else>滿意度調查</a>
            &nbsp;&nbsp;
            <button
              type="button"
              style="height:43px;"
              @click="backToIndex"
              class="position-absolute btn btn-default m-0"
              v-html="'<span style=\'font-size:1rem\'>回上一頁<span>'"
            ></button> 
          </div>
        </div>       
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="container-fluid" :class="{'section-loading': subsLoading}">
      <div class="row">
        <agreed-deduction-data-table
          :height="scrollHeight"
          @update="updateSelection"
          @scheduled-access="ScheduledAccess"
          :table-data="tableData"
          @detail="showDetail"
          :categoryInfo="categoryInfo"
        />
      </div>
    </div>

    <section class="container-fluid fixed-bottom">
      <div class="row">
        <div class="col-12"></div>
        <div class="col-9 col-sm-8 col-md-8"></div>
        <div class="col-3 col-sm-4 col-md-4 text-right">
          <button
            class="btn btn-primary"
            @click="panelOpen('groupModalOpen')"
            :disabled="!selection.length"
          >加入群組</button>
          <button
            class="btn btn-primary mr-0"
            @click="panelOpen('printModalOpen')"
            :disabled="!selection.length"
          >列印名條</button>
        </div>
      </div>
    </section>


    <!-- 列印名條 -->
    <print-modal
    :open="printModalOpen"
    :custs="selection"
    @close="panelClose('printModalOpen')"/>

    <!-- 加入群組 -->
    <group-modal
    :open="groupModalOpen"
    :custs="selection"
    @submit="submitGroup"
    @close="panelClose('groupModalOpen')"/>

    <satisfaction-modal 
    :open="satisfactionModalOpen"
    @report="report"
    @close="panelClose('satisfactionModalOpen')"/>

    <!-- 排訪 -->
	  <scheduled-access
    :open="ScheduledAccessModalOpen"
    :record="currentRecord"
    :cat-info="categoryInfo"
    @close="panelClose('ScheduledAccessModalOpen')"
    @submit="submitScheduledAccess"
    />

    <!-- 目標保單件數 -->
    <agreed-deduction-detail
      :open="agreedDeductionDetailOpen"
      :apc_id="apc_id"
      :apc_name="apc_name"
      @close="panelClose('agreedDeductionDetailOpen')"
    />

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import PrintModal from '@/desktop/components/PrintModal'
import GroupModal from '@/desktop/components/GroupModal'
import Level from '@/components/Level'
import Avatar from '@/components/Avatar'
import SatisfactionModal from '../SatisfactionModal'
import { getAgreedDeduction,getCategoryDetail,
isSatisfactionSurveyFinish, queryBookedVisitEvent } from '@/service'
import $ from 'jquery';
import { downloadFile_m0 } from '@/service'
import { saveAs } from 'file-saver';
import ScheduledAccess from '../ScheduledAccess'
import Tooltip from '@/desktop/components/ToolTip'
import AgreedDeductionDataTable from "@/desktop/components/ListsArea/DataTable/AgreedDeductionDataTable.vue";
import AgreedDeductionDetail from "@/desktop/components/ListsArea/ServiceRight/AgreedDeductionDetail";

export default {
  name: "SubstantialContactDetails",
  mixins: [commonMixin],
  components: {
    Level,
    Avatar,
    PrintModal,
    GroupModal,
    SatisfactionModal,
    ScheduledAccess,
    Tooltip,
    AgreedDeductionDataTable,
    AgreedDeductionDetail
  },
  computed : {
    ...mapGetters([ 'UserInfo' ]),
    isBox() {
     //判斷是否為box
     return this.UserInfo.userType === 'box'
    }
  },
  watch: {
      clickTarget: function(target){
        if(target == 'clickAll' || target == 'clickAll-again') {  //點了全選checkbox
          if(this.checkAll) {  //點了全選
            this.selection = []
            this.distinctid.forEach(data => {
              this.selection.push(data)
            });
          } else {  //取消全選
            this.selection = []
          }
        } else {  //點了其他checkbox
          this.checkAll = this.selection.length == this.distinctid.length
        }
      },    
  },
  props: {
    status: String
  },
  filters: {
    
  },
  data() {
    //data block layout
    return {
      subsLoading: false,
      infoLoading: false,
      printModalOpen: false,
      groupModalOpen: false,
      isBtnEnble: true,
      isLoading_btn: false,
      categoryInfo: {},
      tableData: [],
      tableDataBackup: [],
      visitList: [],
      allIdData:[],
      distinctid:[],
      clickTarget:'',
      checkAllClick: false,
      checkAll: false,
      addPageStatus: false,
      remoteDataMsg: "資料讀取中，請稍候...",
      selection: [],
      IntegratedAddressModalOpen: false,
      message: "",
      title: "",
      screenWidth: document.body.clientWidth > 1208 ? 1280 : document.body.clientWidth,
      scrollHeight: 0,    
      satisfactionModalOpen: false,
      currentRecord: {},
      ScheduledAccessModalOpen: false,
      agreedDeductionDetailOpen: false,
      apc_id: "",
      apc_name: ""
    };
  },
  methods: {
    initCustList () {  // 初始化
      this.subsLoading = true;
      this.checkAll = false;
      this.selection = [];
      getAgreedDeduction(this.$store.state.userInfo.id).then(result => {  // 取得約定扣款獎勵活動名單
        this.subsLoading = false;
        if(result && result.header.status == '200' && result.body){
          let lists = result.body.lists || [];
          let connect = '';
          let apcIdData = '';
          lists.map(item => {
              connect = connect+','+item.apc_id;
          })
          if(connect.length > 0){
            apcIdData = connect.substr(1);
          } else {
            apcIdData = '';
          }
          queryBookedVisitEvent(this.$store.state.userInfo.id,apcIdData).then(visitData => {
            this.subsLoading = false;
            if(visitData.header && visitData.header.status === '200') {
              this.visitList = visitData.body.detail;
              this.tableData = lists.map(item => {
                let visit = {visit: {}};
                this.visitList.forEach(vItem => {
                  if(vItem.csidno == item.apc_id) {
                    visit.visit = vItem;
                  }
                })
                return {
                  id: item.apc_id || '', //要保人id
                  name: item.apc_name || '', //要保人姓名
                  policy_cnt: item.policy_cnt || '', //目標保單件數
                  clc_id: item.clc_id || '', //業務員ID
                  memo: item.memo === 'Y' ? 'Costco卡/SOGO卡待授權' : '', //備註
                  is_apply_cnt : item.is_apply_cnt || 0,
                  is_exist: item.is_exist || false, //判斷是否有客戶資料 
                  ...visit // 寫入排訪資料
                }
              })
              this.allIdData = this.tableData.map(ele => {return ele.ceapcno;});
              this.distinctid = this.allIdData.filter(function(element, index, arr){
                  return arr.indexOf(element) === index;
              });
              this.tableDataBackup = this.tableData.map(ele => {return ele;});
            }
          })
          this.registerHanlink();  // for hard word
        }
      })

      // 取得專區資訊
      this.getTitleInfo()

      // 確認滿意度
      this.checkIsSatisfactionSurveyFinish()
    },
    getTitleInfo () {  // 取得專區資訊
      this.infoLoading = true
      getCategoryDetail(this.$store.state.userInfo.id, this.$store.state.listAreaSerNo).then(result => {
        this.infoLoading = false
        if(result.header && result.header.status == '200'){
          this.categoryInfo = result.body[0]
        }
      })
    },
    columnSorting (fieldName) {
        console.log(`>>>>> columnSorting:${fieldName} <<<<<`)
        //切換表頭圖案
        if(this.order.fieldName == fieldName) {
            this.order.asc = !this.order.asc
        } else {
          console.log('change sort field')
          this.order.fieldName = fieldName
          this.order.asc = true
          console.log(this.order)
        }

        //data排序
        let sortOrder = -1
        if(this.order.asc) {
          sortOrder = 1
        }

        switch (fieldName) {
          default:
          this.tableDataBackup = []  
            setTimeout(() => {
            this.tableDataBackup = [...this.tableData]
            this.tableDataBackup.sort(this.sortCompareFun(sortOrder, fieldName))
            this.allIdData = this.tableDataBackup.map(ele => {return ele.ceapcno})
            this.distinctid = this.allIdData.filter(function(element, index, arr){
              return arr.indexOf(element) === index;
            });
            this.registerHanlink() // 難字顯示
            if(this.checkAll){
              this.selection = []
              this.distinctid.forEach(data => {
              this.selection.push(data)
              });
              this.$emit('update', this.selection)
            }
            }, 20)
            
        }
      },   
    dateCompareFun(sortOrder, property) {
        let vm = this
        return function(a, b) {
          let date_a = new Date(a[property]? a[property] : '1880-01-01').getTime() 
          let date_b = new Date(b[property]? b[property] : '1880-01-01').getTime() 
          let result = (date_a < date_b) ? -1 : 1
          return result * sortOrder
        }
      },
    sortCompareFun(sortOrder, property) {
        return function(a, b) {
          let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
          return result * sortOrder;
        }
      },       
    satisfactionModal() {
        this.panelOpen('satisfactionModalOpen');
    },
    report() {
        this.$toast.info({title:'滿意度調查 已回報'});
        this.isBtnEnble = false;
        this.panelClose('satisfactionModalOpen');
    },
    alreadyDone() {
      this.$toast.info({title: '您已回報過滿意度調查,無法重複操作'});
    },    
    backToIndex() {  // 回上一頁
      this.$emit('change-status', 'STATUS_INTEGRATED_MARKETING_LIST');
    },
    checkIsSatisfactionSurveyFinish () {
      // 檢查是否已回報過滿意度調查
      this.isLoading_btn = true
      isSatisfactionSurveyFinish(this.$store.state.userInfo.id, this.$store.state.listAreaSerNo).then(result => {
        if(result.header && result.header.status == '200') {
          this.isBtnEnble = result.body.isfinish == '0' 
        } else {
          if(result.header && result.header.message) {
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: '查詢滿意度調查失敗,請重新操作'})
          }
        }
        this.isLoading_btn = false
      })
    },
    submitGroup (group) {  // 加入群組導頁至 群組列表
      this.panelClose('groupModalOpen')
      this.$router.push({path:`/group/1`, query:{grp_id: group.grp_id, grp_name: group.grp_name}})
    },
    updateSelection(val) {
      this.selection = val;
    },
    satisfactionModal() {
        this.panelOpen('satisfactionModalOpen');
    },
    download () {
      if (this.$store.state.userInfo.userType === "box") {
        //若内嵌於Box, 將檔案資訊回傳給Box
        this.boxDownload(
          this.categoryInfo.upload_file,
          this.categoryInfo.ser_no
        );
      } else {
        let vm = this;
        downloadFile_m0(this.$store.state.userInfo.id, this.categoryInfo.ser_no, this.categoryInfo.upload_file).then(
          result => {
            if (result.type == "application/json") {
              //  json 為檔案下載失敗
              //  把回傳的 blob 轉為 文字檔後再用 json parse
              let reader = new FileReader();
              reader.onload = function() {
                let unicodeJsonA = JSON.parse(reader.result);
                if (unicodeJsonA.header.message) {
                  vm.setToastMsg(unicodeJsonA.header.message);
                } else {
                  vm.setToastMsg("伺服器連線異常");
                }
              };
              reader.readAsText(result);
            } else {
              //  成功取得檔案  進行下載
              saveAs(result, this.categoryInfo.upload_file);
            }
          }
        );
      }
    },
    ScheduledAccess(record) { //排訪功能
      this.currentRecord = record;
      this.panelOpen('ScheduledAccessModalOpen');
    },
    submitScheduledAccess() { //排訪功能-儲存
      this.panelClose('ScheduledAccessModalOpen');
      // 資料初始化
      this.initCustList();
    },
    callBoxVisit(data) {
      //連至Box排訪
      this.boxVisit(data, this.categoryInfo);
    },
    // 開啟目標保單件數視窗
    showDetail(apc_id,apc_name){
      this.apc_id = apc_id;
      this.apc_name = apc_name;
      this.panelOpen("agreedDeductionDetailOpen");
    }
  },
  mounted() {
    // 初始化頁面
    this.initCustList()

    // 監聽視窗寬度
    const self = this

    window.onresize = () => {
      return (() => {
        if(document.body.clientWidth > 1220) {
          window.screenWidth = 1220;
          self.screenWidth = 1220
        } else {
          window.screenWidth = document.body.clientWidth;
          self.screenWidth = window.screenWidth;
        }
      })();
    };

    this.scrollHeight =  parseInt($(window).height()) - $('tbody').offset().top - 85 ;
    $(window).bind('resize', function(event) {
      self.scrollHeight = parseInt($(window).height()) - $('tbody').offset().top - 85 ;
    });
    $(".tab-content").css("padding-bottom","62px");    

  },
  
};
</script>

<style lang="scss" scoped>

.newTable thead tr,.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.newTable tbody {
  display: block;
  // height: 552px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;
  
  &::-webkit-scrollbar {
    width: 17px; 
    border: 0;
    box-shadow: none;
  }
  
  &::-webkit-scrollbar-track
  {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb
  {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}

</style>